import { FETCH_BENEFITS_API, generateBFFUrl } from '@/configs/apiEndPoints';
import { GenericError } from '@/errors/GenericServerError';
import { AxiosResponse } from 'axios';
import axiosInstance from './axiosConfig';
import generateHttpHeaders from './axiosConfig/generateHttpHeaders';
import { FetchBenefitsResponse, TierType } from '@/types/benefits';

export const fetchBenefits = (
  tier: TierType,
  variantId?: string,
  agreementId?: string,
  assetId?: string,
  serverCookie?: any,
): Promise<FetchBenefitsResponse> => {
  return axiosInstance
    .get(generateBFFUrl(`${FETCH_BENEFITS_API}`), {
      headers: generateHttpHeaders(serverCookie),
      params: {
        tier,
        variantId,
        agreementId,
        assetId,
      },
    })
    .then(({ data }) => {
      return data;
    })
    .catch((error: any) => {
      const { response } = error;
      const { data, status, statusText } = response as AxiosResponse;
      throw new GenericError('Something went wrong', status, statusText, data);
    });
};
